import html2canvas from "html2canvas";
import { useEffect, useRef, useState } from "react";

function ReceiptPrint() {
  const [printers, setPrinters] = useState([]);
  const [selectedPrinter, setSelectedPrinter] = useState("");
  const receiptRef = useRef();

  const orders = [
    { name: "برگر", quantity: 2, price: 50000 },
    { name: "پیتزا", quantity: 1, price: 90000 },
    { name: "سالاد", quantity: 3, price: 20000 },
  ];
  const discount = 0.1;
  const total = orders.reduce((acc, item) => acc + item.price * item.quantity, 0);
  const finalTotal = total - total * discount;

  useEffect(() => {
    connectToQZ();
  }, []);

  const connectToQZ = async () => {
    try {
      if (!window.qz) {
        alert("QZ Tray بارگذاری نشده است.");
        return;
      }

      if (!window.qz.websocket.isActive()) {
        await window.qz.websocket.connect();
      }

      const availablePrinters = await window.qz.printers.find();
      setPrinters(availablePrinters);
      setSelectedPrinter(availablePrinters[0]);
    } catch (err) {
      console.error("خطا:", err);
      alert("اتصال به QZ Tray ممکن نیست.");
    }
  };

  const handlePrintImage = async () => {
    try {
      if (!selectedPrinter) {
        alert("لطفاً یک پرینتر انتخاب کنید.");
        return;
      }

      const canvas = await html2canvas(receiptRef.current, {
        scale: 2,
        useCORS: true,
      });

      const imageBase64 = canvas.toDataURL("image/png").replace(/^data:image\/png;base64,/, "");

      const config = window.qz.configs.create(selectedPrinter, {
        encoding: null, // نباید UTF-8 باشد برای تصویر
        rasterize: true,
      });

      const data = [
        {
          type: "image",
          format: "base64",
          data: imageBase64,
        },
      ];

      await window.qz.print(config, data);
      alert("چاپ انجام شد.");
    } catch (err) {
      console.error("خطا در چاپ:", err);
      alert("خطا در چاپ تصویر.");
    }
  };

  return (
    <div style={{ padding: 20, direction: "rtl", fontFamily: "Vazir, Tahoma" }}>
      <h3>چاپ رسید</h3>

      <label>انتخاب پرینتر:</label>
      <select
        value={selectedPrinter}
        onChange={(e) => setSelectedPrinter(e.target.value)}
      >
        {printers.map((printer, idx) => (
          <option key={idx} value={printer}>
            {printer}
          </option>
        ))}
      </select>

      <button onClick={handlePrintImage}>چاپ تصویری رسید</button>

 <div
  ref={receiptRef}
  style={{
    fontFamily: 'Vazir',
    direction: 'rtl',
    width: '280px',
    padding: '10px',
    background: '#fff',
    color: '#000',
    fontSize: '14px',
    marginTop: '20px',
    border: '1px solid #ccc',
    borderRadius: '8px',
  }}
>
  <div style={{ textAlign: 'center', fontWeight: 'bold', fontSize: '18px' }}>
    منوآف
  </div>
  <div style={{ textAlign: 'center', fontSize: '16px', marginBottom: '10px' }}>
    فاکتور فروش
  </div>

  <table style={{ width: '100%', borderCollapse: 'collapse' }}>
    <thead>
      <tr style={{ borderBottom: '1px solid #000' }}>
        <th style={{ textAlign: 'right', padding: '4px' }}>نام آیتم</th>
        <th style={{ textAlign: 'center', padding: '4px' }}>تعداد</th>
        <th style={{ textAlign: 'center', padding: '4px' }}>قیمت</th>
        <th style={{ textAlign: 'left', padding: '4px' }}>جمع</th>
      </tr>
    </thead>
    <tbody>
      {orders.map((item, idx) => (
        <tr key={idx}>
          <td style={{ padding: '4px' }}>{item.name}</td>
          <td style={{ textAlign: 'center', padding: '4px' }}>{item.quantity}</td>
          <td style={{ textAlign: 'center', padding: '4px' }}>
            {item.price.toLocaleString()}
          </td>
          <td style={{ textAlign: 'left', padding: '4px' }}>
            {(item.quantity * item.price).toLocaleString()}
          </td>
        </tr>
      ))}
    </tbody>
  </table>

  <hr />

  <div>تخفیف: {discount * 100}%</div>
  <div style={{ fontWeight: 'bold' }}>
    مبلغ نهایی: {finalTotal.toLocaleString()} تومان
  </div>

  <div style={{ marginTop: '20px', textAlign: 'center' }}>
    با تشکر از خرید شما
  </div>
</div>

       </div>
  );
}

export default ReceiptPrint;
